import React, { useState } from "react";
import { Button, CircularProgress, Dialog } from "@mui/material";
import styles from "./Edufin.module.css";
import { useSelector } from "react-redux";
import DeleteIcon from "../../../../../assets/images/blinkingDeleteIcon.svg";
import CloseIcon from "@mui/icons-material/Close";

function DeletePopupForEdufin(props: any) {
  const {
    handlePopupYesButton,
    handlePopupNoButton,
    loading,
    isOpen,
    setIsOpen,
  } = props;
  return (
    <Dialog
      open={isOpen}
      sx={{
        zIndex: "9999999",
        minWidth: "414px",
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "500px",
          maxHeight: "250px",
          minHeight: "155px",
          padding: "34px",
          borderRadius: "8px",
          boxShadow:
            "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
          left: "10%",
          background: "#FFFFFF",
          overflow: "hidden",
        },
      }}
    >
      <div className={styles.deactivationPopup}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: "10px",
            }}
          >
            <div>
              <img src={DeleteIcon} />
            </div>
            <div>
              <div className={styles.popupHead}>Delete Loan Application</div>
              <div className={styles.popupSubHead}>
                Are you sure you want to delete this Application? This action
                cannot be undone.
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <CloseIcon
              onClick={() => {
                setIsOpen(false);
              }}
            />
          </div>
        </div>

        <div className={styles.popupButtonDiv}>
          <Button
            sx={{
              textTransform: "capitalize",
              backgroundColor: "#ffffff",
              color: "#344054",
              border: "1px solid #D0D5DD",
            }}
            onClick={() => {
              handlePopupNoButton();
              setIsOpen(false);
            }}
            fullWidth
          >
            Cancel
          </Button>
          <Button
            sx={{
              textTransform: "capitalize",
              backgroundColor: "#EC3939",
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "#EC3939",
              },
            }}
            onClick={() => {
              handlePopupYesButton();
              // setIsOpen(false);
            }}
            fullWidth
            disabled={loading}
          >
            {/* Yes */}
            {loading ? (
              <CircularProgress size={18} color={"inherit"} />
            ) : (
              "Delete"
            )}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

export default DeletePopupForEdufin;
